import BvCallWidget, { type Props as CallWidgetProps } from '@bv/components/voip/call/widget/BvCallWidget.vue';
import { WidgetInjector } from '@bv/utils/widget-injector';

/**
 * Singleton instance of the WidgetInjector, specifically for managing the BvCallWidget.
 *
 * This manager is pre-configured to inject and control the {@link BvCallWidget}
 * component, mounting it into a DOM element with the ID 'call-widget-container'.
 *
 * It should be used throughout the application to programmatically control the call
 * widget's lifecycle (e.g., `initWidget`, `updateProps`, `destroyWidget`).
 *
 * @type {WidgetInjector<CallWidgetProps>}
 */
export const callWidget: WidgetInjector<CallWidgetProps> = new WidgetInjector<CallWidgetProps>(BvCallWidget, {
  containerId: 'call-widget-container',
});

export default callWidget;
